import { select, call, put, takeLatest, cancelled } from 'redux-saga/effects';
import { mapDataToShapes } from 'api/rex/mapShapes';
import { postWithToken } from 'api/network';
import {
  convertZoomToShapesAutoGeoType,
  getManualShapesGeoTypesForZoomLevel,
} from 'api/rex/spatial';
import {
  setMapLocation,
  setMapIsLoading,
  setShapesData,
  setDropDownGeoType,
  setShapes,
  setShapesGeoType,
} from 'store/actions';

async function getMarkets(geoType, bounds, zoom, geoIds) {
  // REVUE API
  const requestDto = {
    zoomLevel: zoom,
    clusterType: geoType,
    bounds,
    geoIds,
  };

  const url = `/api/explore/GetMarkets`;
  const response = await postWithToken(url, requestDto);

  const data = await response.json();
  return data;
}

function getShapesDataParams({ assumptionMapState }) {
  const { bounds, zoom, shapesGeoType } = assumptionMapState;
  return { bounds, zoom, shapesGeoType };
}

function* fetchUpdatedData() {
  try {
    const { bounds, zoom, shapesGeoType } = yield select(getShapesDataParams);

    if (shapesGeoType) {
      yield put(setMapIsLoading(true, 'SHAPES', 'Loading Shapes Data...'));
      let requestedGeoType;
      if (shapesGeoType === 'auto') {
        requestedGeoType = convertZoomToShapesAutoGeoType(zoom);
      } else {
        if (
          getManualShapesGeoTypesForZoomLevel(zoom).find(
            (type) => type.value === shapesGeoType
          )?.enabled
        ) {
          // Use user selected type if it is allowed for current zoom level
          requestedGeoType = shapesGeoType;
        } else {
          // Else revert to auto mode if zoom no longer fits
          yield put(setShapesGeoType('auto'));
          return;
        }
      }
      const shapesData = yield call(getMarkets, requestedGeoType, bounds, zoom);

      yield put(setShapesData(shapesData));
      yield put(setDropDownGeoType(requestedGeoType));

      const shapes = yield call(mapDataToShapes, shapesData);
      yield put(setShapes(shapes));
      yield put(setMapIsLoading(false, 'SHAPES'));
    } else {
      yield put(setShapesData([]));
      yield put(setDropDownGeoType(null));
      const shapes = yield call(mapDataToShapes, []);
      yield put(setShapes(shapes));
    }
  } catch (error) {
    console.log(error);
    yield put(setMapIsLoading(false, 'SHAPES'));
  } finally {
    if (yield cancelled()) {
      yield put(setMapIsLoading(false, 'SHAPES'));
    }
  }
}

export function* loadAssumptionShapesDataSaga() {
  yield takeLatest(setShapesGeoType, fetchUpdatedData);
  yield takeLatest(setMapLocation, fetchUpdatedData);
}
